import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="messageevent" id="messageevent"></a>
    <h1 {...{
      "id": "windowmessageevent"
    }}>{`window.MessageEvent`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/MessageEvent"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/MessageEvent`}</a>{`  `}</p>
    <a name="new-messageevent-new" id="new-messageevent-new"></a>
    <h2 {...{
      "id": "messageeventdata-origin-source-eventinit"
    }}>{`MessageEvent(data, origin, source, eventInit)`}</h2>
    <p>{`Creates an instance of MessageEvent.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`origin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`source`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`eventInit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="messageevent-data" id="messageevent-data"></a>
    <h2 {...{
      "id": "data--string"
    }}>{`data ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - returns the data sent by the server.  `}</p>
    <a name="messageevent-origin" id="messageevent-origin"></a>
    <h2 {...{
      "id": "origin--string"
    }}>{`origin ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - returns the origin of the message.  `}</p>
    <a name="messageevent-source" id="messageevent-source"></a>
    <h2 {...{
      "id": "source--string"
    }}>{`source ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - returns the string indicating the messageEventSource.  `}</p>
    <a name="event-type" id="event-type"></a>
    <h2 {...{
      "id": "type"
    }}>{`type`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-istrusted" id="event-istrusted"></a>
    <h2 {...{
      "id": "istrusted--boolean"
    }}>{`isTrusted : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-target" id="event-target"></a>
    <h2 {...{
      "id": "target--node"
    }}>{`target : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-currenttarget" id="event-currenttarget"></a>
    <h2 {...{
      "id": "currenttarget--node"
    }}>{`currentTarget : `}<inlineCode parentName="h2">{`Node`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-bubbles" id="event-bubbles"></a>
    <h2 {...{
      "id": "bubbles--boolean"
    }}>{`bubbles : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-cancelable" id="event-cancelable"></a>
    <h2 {...{
      "id": "cancelable--boolean"
    }}>{`cancelable : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-composed" id="event-composed"></a>
    <h2 {...{
      "id": "composed--boolean"
    }}>{`composed : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-eventphase" id="event-eventphase"></a>
    <h2 {...{
      "id": "eventphase"
    }}>{`eventPhase`}</h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-defaultprevented" id="event-defaultprevented"></a>
    <h2 {...{
      "id": "defaultprevented--boolean"
    }}>{`defaultPrevented : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong></p>
    <a name="event-returnvalue" id="event-returnvalue"></a>
    <h2 {...{
      "id": "returnvalue--"
    }}>{`returnValue : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <a name="event-initevent" id="event-initevent"></a>
    <h2 {...{
      "id": "initeventtypearg-bubblesarg-cancelablearg"
    }}>{`initEvent(typeArg, bubblesArg, cancelableArg)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`typeArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`bubblesArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cancelableArg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <a name="event-composedpath" id="event-composedpath"></a>
    <h2 {...{
      "id": "composedpath"
    }}>{`composedPath()`}</h2>
    <p>{`Returns the event's path`}</p>
    <p><strong parentName="p">{`See`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath"
        }}>{`https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://dom.spec.whatwg.org/#dom-event-composedpath"
        }}>{`https://dom.spec.whatwg.org/#dom-event-composedpath`}</a></li>
    </ul>
    <a name="event-preventdefault" id="event-preventdefault"></a>
    <h2 {...{
      "id": "preventdefault"
    }}>{`preventDefault()`}</h2>
    <a name="event-stopimmediatepropagation" id="event-stopimmediatepropagation"></a>
    <h2 {...{
      "id": "stopimmediatepropagation"
    }}>{`stopImmediatePropagation()`}</h2>
    <a name="event-stoppropagation" id="event-stoppropagation"></a>
    <h2 {...{
      "id": "stoppropagation"
    }}>{`stopPropagation()`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      